import React from 'react';
import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import { string, number, object } from 'prop-types';
import { formatMoney } from '../../util/currency';
import { DISPLAY_CURRENCY } from '../../util/constants/listing';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './CartInfoPanel.module.css';

const { Money } = sdkTypes;

const CardOrderSummary = props => {
    const { rootClassName, className, totalPrice, discount, originalPrice, numberOfItems, layout } = props;
    const intl = useIntl();
    const isCheckout = layout === 'checkout';
    const classes = classNames(rootClassName || css.orderSummary, className);

    const originalPriceDisplay = formatMoney(
        intl,
        new Money(originalPrice.amount, originalPrice.currency),
        DISPLAY_CURRENCY
    );
    const totalPriceDisplay = formatMoney(
        intl,
        new Money(totalPrice.amount, totalPrice.currency),
        DISPLAY_CURRENCY
    );
    const discountDisplay = formatMoney(
        intl,
        new Money(discount.amount, discount.currency),
        DISPLAY_CURRENCY
    );



    return (
        <div className={classes}>
            <div className={classNames(css.orderSummaryTitle, { [css.priceCheckout]: isCheckout })}>
                <FormattedMessage id="CartInfoPanel.orderSummaryTitle" />
            </div>
            <div className={classNames({ [css.priceCheckout]: isCheckout })}>
                <FormattedMessage id="CartInfoPanel.totalItems" values={{ numberOfItems }} />
            </div>

            <div className={classNames({ [css.priceCheckout]: isCheckout })}>
                <FormattedMessage id="CartInfoPanel.itemsTotal" />
            </div>
            <span className={classNames({ [css.priceCheckout]: isCheckout })}>{originalPriceDisplay}</span>

            <div className={classNames({ [css.priceCheckout]: isCheckout })}>
                <FormattedMessage id="CartInfoPanel.itemsDiscount" />
            </div>
            <span className={classNames({ [css.priceCheckout]: isCheckout })}>{discountDisplay}</span>

            <div className={css.divider} />
            <div className={css.divider} />

            <div className={classNames(css.orderTotalTitle, { [css.priceCheckout]: isCheckout })}>
                <FormattedMessage id="CartInfoPanel.orderTotal" />
            </div>
            <span className={classNames(css.orderTotal, { [css.priceCheckout]: isCheckout })}>{totalPriceDisplay}</span>
        </div>
    );
};

CardOrderSummary.defaultProps = {
    rootClassName: null,
    className: null,
};

CardOrderSummary.propTypes = {
    rootClassName: string,
    className: string,
    totalPrice: object.isRequired,
    discount: object.isRequired,
    originalPrice: object.isRequired,
    numberOfItems: number,
};

export default CardOrderSummary;
